import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { environment } from '../../../environments/environment';
import { ClientPurchaseOrder, ClientPurchaseOrderSearchCommand } from '../../models/order/client-purchase-order';

@Injectable({ providedIn: 'root' })
export class ClientPurchaseOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/client-purchase-order';

  public getById(id: string): Observable<ApiResponse<ClientPurchaseOrder>> {
    return this.httpClient.get<ApiResponse<ClientPurchaseOrder>>(`${this.baseUrl}/${id}`);
  }

  public search(
    command: ClientPurchaseOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
  ): Observable<ApiResponse<PaginatedApiResponse<ClientPurchaseOrder>>> {
    const params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ClientPurchaseOrder>>>(`${this.baseUrl}/search`, command, { params });
  }
}
